var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.price.special)?_c('div',{staticClass:"discount-label",class:{ 'circle': _vm.onProductCard, 'three-digits': _vm.isDiscountThreeDigits }},[_vm._v("\n  -"+_vm._s(_vm.discount)+" %\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }